import { ISearchScope } from "@cayo/shared/api/types/schema";
import { ObjectPickerProps } from "./";

export const mapPropsToSearchScopes = (props: ObjectPickerProps): ISearchScope[] => {
  if (props.searchScopes?.length) {
    return props.searchScopes;
  }

  return [
    {
      name: "",
      path: props.queryPath || "",
      body: props.body,
      columns: props.columns || [],
    },
  ];
};
